import { datadogLogs, StatusType } from "@datadog/browser-logs";
import { environment, Environment } from "app/environment/environment";
import { devLog } from "shared/utils/devLog";

let isInitialized = false;
let hasWarnedAboutInitialization = false;
const enabledEnvironments = [
  Environment.Production,
  Environment.Stage,
  Environment.Test,
];

const env = environment();
const version = String(import.meta.env.APP_VERSION);

export const LogLevel = StatusType; // temporary

export const initDatadogBrowserLogs = () => {
  if (!isInitialized && enabledEnvironments.includes(env)) {
    datadogLogs.init({
      clientToken: "pubd124844af411c02a2b8de9a5fe35085b",
      site: "datadoghq.eu",
      forwardErrorsToLogs: true,
      service: "drops-frontend",
      env: env.toLowerCase(),
      version,
      sessionSampleRate: 100,
      trackingConsent: "granted",
      forwardConsoleLogs: ["error"],
    });

    isInitialized = true;
  } else if (!isInitialized && !hasWarnedAboutInitialization) {
    // eslint-disable-next-line no-console
    console.warn(
      `Datadog Log Collection not initialized for environment: ${env}`,
    );
    hasWarnedAboutInitialization = true;
  }
};

export const log = (
  level: StatusType,
  source: string,
  message: string,
  error?: any,
) => {
  devLog(message);

  if (error instanceof Error) {
    datadogLogs.logger.log(message, { source }, level, error);
    return;
  }

  if (error != null) {
    const err = new Error(String(error));
    datadogLogs.logger.log(message, { source }, level, err);
    return;
  }

  datadogLogs.logger.log(message, { source }, level);
};
